/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConversationDto } from '../../models/conversation-dto';

export interface GetnotificationsConversationUpdatedSchema$Params {
}

export function getnotificationsConversationUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsConversationUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationDto>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsConversationUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConversationDto>;
    })
  );
}

getnotificationsConversationUpdatedSchema.PATH = '/api/hubs/notifications/ConversationUpdated';
